export const name = "Richard Martin"
export const tagline = "Building digital products, brands & experience"
export const bio = "I'm an International Business graduate from Maryville College, and I spent the past 3 months traveling Europe."
export const badges = [
    {
        name: "richdmartin",
        url: "https://richdmart.in",
        icon: "icon"
    },
    {
        name: "swiftech",
        url: "https://swifte.ch",
        icon: "icon"
    },
    {
        name: "OneResume",
        url: "https://oneresume.us",
        icon: "icon"
    },
    {
        name: "GitHub",
        url: "https://github.com/richdmartin13",
        icon: "icon"
    },
    {
        name: "LinkedIn",
        url: "https://linkedin.com/in/richdmartin",
        icon: "icon"
    },
];
export const buttons = [
    {
        name: "Grab Time",
        url: "#",
    },
    {
        name: "Message Me",
        url: "mailto:richdmart.in"
    }
]